import * as ft from "../constants/FieldType";
import * as FieldType from "../constants/FieldType";
import * as ts from "../common/Translator";
import * as meta from "../common/Metadata";
import {findFieldMetadata} from "../common/Metadata";
import * as ClientCache from "../login/ClientCache";
import {getAllowedValuesFor, getFieldStyle, isFeatureEnabled, isFieldValuesRestricted, isNotColorField} from "../login/ClientCache";
import {userCanViewField} from "../login/Security";
import * as EditScreenFieldLayout from "../constants/EditScreenFieldLayout";
import * as CommonFieldIds from "../constants/CommonFieldIds";
import * as widgets from "./Widgets";
import {isAnyEqualToFirst, isAnyTrue} from "../common/NamaCommon";
import {isPassword} from "../grid/GridGetterAndSetterCallbacks";

let fieldNumber = 0;
let numOfWidgetsInCurrentROw = 0;
let widgetContainer;

/**
 *
 * @param {namaTypes.CompositeEditScreenField} field
 * @param {namaTypes.NaMaMetaData} entityMetaData
 * @param {EditPresenter} presenter
 * @return {*}
 */
export function renderField(field, entityMetaData, presenter, mustAddNewWidgetContainer, compositeFieldId, fieldMetadata) {
    /*
    /**
     * @type {namaTypes.FieldMetaData}
     */
    if (!fieldMetadata)
        fieldMetadata = meta.findFieldMetadata(field.id, entityMetaData) || {};
    let fieldType = fieldMetadata.fieldType;
    if (!isFeatureEnabled(fieldMetadata.relatedToFeature))
        return "";
    if (!userCanViewField(presenter.entityType, field.id))
        return "";
    let req = {fieldMetadata: fieldMetadata, owner: presenter, width: getFieldWidth(field)};
    let widget = intiWidget(field, entityMetaData, presenter, fieldMetadata, req);
    if (mustAddNewWidgetContainer) {
        widgetContainer = createWidgetContainer(field.layout, presenter.isCriteriaWidget);
        let ownerId = entityMetaData ? entityMetaData.owner.ownerId : null;
        if (!presenter.isCriteriaWidget)
            widgetContainer.find(".form-group").append(addWidgetLabel(ownerId, field, compositeFieldId, fieldMetadata.required));
    }
    if (fieldType === FieldType.Text || fieldType === FieldType.BigText) {
        let divContainer = $(`<div id = ${field.id}></div>`);
        divContainer.append(widget);
        widgetContainer.find(".form-group").append(divContainer);
    } else {
        widgetContainer.find(".form-group").append(widget);
    }

    return widget ? widgetContainer : "";
}

export function resetNumOfWidgets() {
    numOfWidgetsInCurrentROw = 0;
}


function createWidgetContainer(layout, isCriteriaWidget) {
    let shouldStartNewLine = false, shouldEndCurrentLine = false, columnSize = 3;
    if (!isCriteriaWidget) {
        if (layout === EditScreenFieldLayout.alone) {
            columnSize = 3;
            numOfWidgetsInCurrentROw += 4;
            shouldStartNewLine = true;
        }
        else if (layout === EditScreenFieldLayout.spanned2 || layout === EditScreenFieldLayout.spanned) {
            columnSize = 12;
            numOfWidgetsInCurrentROw += 4;
        }
        else {
            columnSize = 3;
            numOfWidgetsInCurrentROw += 1;
        }
        if (numOfWidgetsInCurrentROw > 4) {
            shouldStartNewLine = true;
        }
        if (numOfWidgetsInCurrentROw >= 4) {
            shouldEndCurrentLine = true;
            numOfWidgetsInCurrentROw = 0;
        }
    }
    else {
        columnSize = 6;
    }
    return widgetContainerHTML(columnSize, shouldStartNewLine, shouldEndCurrentLine);
}

function widgetContainerHTML(columnSize, shouldStartNewLine, shouldEndCurrentLine) {
    let html = $("<div/>");
    if (shouldStartNewLine)
        html.append(newLine());
    let sizeKlass = columnSize == "12" ? "col-12" : "col-md-" + columnSize;
    html.append(`
        <div class="form-widgets mb-1 ${sizeKlass}">
            <div class="form-group row align-items-center w-100 m-auto"/>
        </div>`);
    if (shouldEndCurrentLine)
        html.append(newLine());
    return html.contents();
}

function newLine() {
    return $(`<div class="clearfix"/>`);
}

function addWidgetLabel(ownerId, field, compositeFieldId, required) {
    let baseTitle = compositeFieldId ? ts.translate(compositeFieldId, ownerId) : undefined;
    let title = ts.translateTitledId(ownerId, field);
    if (baseTitle && baseTitle !== title)
        title = baseTitle + " - " + title;
    let fieldId = field.id + (++fieldNumber);
    let labelContainer = $(`<div class="fieldLabel" style="display: block"><label class="control-label" for="${fieldId}">${title}</label></div>`);
    if (required)
        labelContainer.find(".control-label").addClass("required-field");
    return labelContainer;
}

/**
 *
 * @param {namaTypes.FieldMetaData} fieldMetaData
 * @returns {boolean}
 */
export function fieldHasSuggestionProvider(fieldMetaData, entityType) {
    if (!fieldMetaData)
        return false;
    if (CommonFieldIds.CODE === fieldMetaData.fieldId)
        return true;
    let fieldStyle = getFieldStyle(entityType, fieldMetaData.fieldId);
    if (fieldStyle && isAnyTrue(fieldStyle.disableSuggestionProvider))
        return false;
    fieldMetaData.fieldInformation = fieldMetaData.fieldInformation || {};
    if (fieldMetaData && fieldMetaData.fieldInformation.hasSuggestionProvider)
        return true;
    let suggestionProviders = ClientCache.getCustomGUISettings().tooltipsAndReportsAndRevise.suggestionProviders
        [entityType + "." + fieldMetaData.fieldId];
    if (suggestionProviders != null)
        return true;
    return false;
}

export function fieldAllowedValues(fieldId, presenter) {
    let fieldMetaData = findFieldMetadata(fieldId, presenter.metaData);
    if (!fieldMetaData)
        return [];
    fieldMetaData.allowedValues = fieldMetaData.allowedValues || [];
    return fieldMetaData.allowedValues;
}

function createDropDownForTextField(fieldMetadata, ownerId, req) {
    fieldMetadata.allowedValues = getAllowedValuesFor(ownerId, fieldMetadata.fieldId);
    return new widgets.DropDownListWidget(req);
}
export function intiWidget(field, entityMetaData, presenter, fieldMetadata, req) {
    return intiWidget_(field, entityMetaData, presenter, fieldMetadata, req).render();
}

export function intiWidget_(field, entityMetaData, presenter, fieldMetadata, req) {
    let fieldType = fieldMetadata.fieldType;
    let ownerId = req.owner.entityType;
    let isCodeOrAltCode = field.id === CommonFieldIds.CODE || field.id === CommonFieldIds.ALT_CODE;
    let isAutoComplete = fieldHasSuggestionProvider(fieldMetadata, presenter.entityType) && fieldType !== ft.Reference && !isCodeOrAltCode;
    if (isAutoComplete)
    {
        if (fieldType === ft.BigText)
            return new widgets.LongTextWidget(req, field.layout);
        return new widgets.AutoCompleteWidget(req);
    }
    if (isCodeOrAltCode)
        return new widgets.CodeFieldWidget(req);

    if (fieldType === ft.Reference)
        return new widgets.ReferenceWidget(req);

    if (fieldType === ft.Genericreference)
        return new widgets.GenericReferenceWidget(req);
    if (isAnyEqualToFirst(fieldType, ft.Integer, ft.Long, ft.Decimal, ft.Password, ft.FieldID)) {
        if (isFieldValuesRestricted(ownerId, fieldMetadata.fieldId))
            return createDropDownForTextField(fieldMetadata, ownerId, req);
        if (fieldType === ft.Integer || fieldType === ft.Long)
            return new widgets.IntegerFieldWidget(req);
        if (fieldType === ft.Decimal)
            return new widgets.DecimalFieldWidget(req);
        if (fieldType === ft.Password)
            return new widgets.PasswordWidget(req);
        if (fieldType === ft.FieldID)
            return new widgets.AutoCompleteWidget(req);
    }
    if (fieldType === ft.BigText) {
        if (ClientCache.isRichTextField(presenter.entityType, field.id))
            return new widgets.RichTextEditorWidget(req);
        else
            return new widgets.LongTextWidget(req, field.layout);
    }
    if (fieldType === ft.Date)
        return new widgets.DateFieldWidget(req);

    if (fieldType === ft.DateAndTime)
        return new widgets.DateTimeFieldWidget(req);

    if (fieldType === ft.Boolean)
        return new widgets.BooleanFieldWidget(req);

    if (isAnyEqualToFirst(fieldType, ft.Enum, ft.EntityType, ft.FeatureID)) {
        return new widgets.DropDownListWidget(req);
    }
    if (fieldType === ft.Time)
        return new widgets.TimeFieldWidget(req);

    if (fieldType === ft.Color) {
        if (isFieldValuesRestricted(ownerId, fieldMetadata.fieldId))
            return createDropDownForTextField(fieldMetadata, ownerId, req);
        else if (isNotColorField(ownerId, fieldMetadata.fieldId))
            return new widgets.TextFieldWidget(req);
        else
            return new widgets.ColorFieldWidget(req);
    }
    if (fieldType === ft.Binary)
        return new widgets.AttachmentWidget(req);

    if (isFieldValuesRestricted(ownerId, fieldMetadata.fieldId))
        return createDropDownForTextField(fieldMetadata, ownerId, req);
    if (isPassword(ownerId, fieldMetadata))
        return new widgets.PasswordWidget(req);
    return new widgets.TextFieldWidget(req);
}

export function getFieldWidth(field) {
    if (!field.widgetPercentage || !field.titlePercentage)
        return -1;
    return field.widgetPercentage !== -1 ? field.widgetPercentage : field.titlePercentage
}


